<template>
  <div class="chart-content">
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from "./chart.vue";
export default {
  props: {
    cdata: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Chart,
  },
};
</script>
<style lang="less" scoped>
.chart-content {
  width: 100%;
  box-sizing: border-box;
}
</style>
